"use client";

import React from "react";
import { Truck, Store, Utensils, CalendarDays, TriangleAlert as AlertTriangle, Building2 } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface ApplicationItem {
  title: string;
  description: string;
  icon: LucideIcon;
}
const applications: ApplicationItem[] = [{
  title: "Food distribution",
  description: "Potential temporary refrigerated storage for shipments during staging and logistics handoffs. Confirm requirements with our team.",
  icon: Truck
}, {
  title: "Grocery operations",
  description: "Potential temporary refrigerated storage for seasonal inventory, store remodels, or cooler overflow. Confirm requirements with our team.",
  icon: Store
}, {
  title: "Catering",
  description: "Potential temporary refrigerated storage for catering ingredients and prepared food. Confirm temperature and loading requirements with our team.",
  icon: Utensils
}, {
  title: "Events",
  description: "Potential temporary refrigerated storage for food and beverages at events. Confirm site access, temperature, and loading requirements with our team.",
  icon: CalendarDays
}, {
  title: "Emergency cold storage",
  description: "Potential temporary refrigerated storage during equipment downtime or facility disruptions, subject to location, timing, and availability.",
  icon: AlertTriangle
}, {
  title: "Commercial projects",
  description: "Potential temporary refrigerated storage for planned commercial projects, facility maintenance, or operational needs. Confirm suitability with our team.",
  icon: Building2
}];
export default function PotentialApplications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section id="potentialapplications" data-nav="light" ref={ref} className="bg-background text-foreground py-16 sm:py-24 transition-opacity duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground font-default">
            Potential Applications
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {applications.map((item, index) => {
          const Icon = item.icon;
          return <Card key={item.title} data-index={index} className="bg-card text-card-foreground border border-border shadow-xs hover:shadow-md transition-all duration-200 flex flex-col justify-start rounded-xl p-2 sm:p-4">
                <CardHeader className="flex flex-col gap-4 pb-2">
                  <div className="size-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <Icon className="size-6" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground font-default">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-muted-foreground leading-relaxed text-sm sm:text-base">
                    {item.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}